import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { SortTypeEnum } from "src/domain/client";
import IOption from "src/domain/extentions/option";

@Component({
  selector: "vw-sorting-select",
  templateUrl: "./sorting-select.component.html",
})
export class SortingSelectComponent implements OnInit, OnDestroy {
  @Output() valueChanged$ = new EventEmitter<SortTypeEnum>();

  formSubscription?: Subscription;

  options: IOption[] = [
    {
      displayName: this.translateService.instant(
        `sortingOptions.${SortTypeEnum.AlphabeticalAscending}`,
      ),
      value: SortTypeEnum.AlphabeticalAscending,
    },
    {
      displayName: this.translateService.instant(
        `sortingOptions.${SortTypeEnum.AlphabeticalDescending}`,
      ),
      value: SortTypeEnum.AlphabeticalDescending,
    },
    // {
    //   displayName: this.translateService.instant(
    //     `sortingOptions.${SortTypeEnum.PriceAscending}`
    //   ),
    //   value: SortTypeEnum.PriceAscending,
    // },
    // {
    //   displayName: this.translateService.instant(
    //     `sortingOptions.${SortTypeEnum.PriceDescending}`
    //   ),
    //   value: SortTypeEnum.PriceDescending,
    // },
  ];

  form = new FormGroup({
    sort: new FormControl(SortTypeEnum.AlphabeticalAscending),
  });

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.formSubscription = this.form.valueChanges.subscribe((val) => {
      this.valueChanged$.emit(val.sort ?? undefined);
    });
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }
}
